import { createContext } from 'react'

export interface FocusHorizonTarget {
  title: string
  subNodeId?: string
  workspaceId?: string
}

export interface FocusHorizonContextValue {
  activeTarget: FocusHorizonTarget | null
  startFocus: (target: FocusHorizonTarget) => void
  endFocus: () => void
}

export const FocusHorizonContext = createContext<FocusHorizonContextValue | undefined>(undefined)
